import styled from 'styled-components';

export const Content = styled.div<TextProps>`
	font-weight: ${({ $fontWeight }) =>
		$fontWeight ? `${$fontWeight}` : 'inherit'};
	font-size: ${({ $fontSize }) => ($fontSize ? `${$fontSize}px` : 'inherit')};
	color: ${({ $color }) => ($color ? `${$color}` : '#575757')};
	padding: ${({ $padding }) => ($padding ? `${$padding}` : '0')};
`;

interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
	$fontWeight?: number;
	$fontSize?: number;
	$color?: string;
	$padding?: string;
}
